import React, { useCallback, useEffect, useRef, useState } from 'react'

import TinyMCEEditor from '~/ui-components/TinyMCEEditor'

import { FieldProps } from '../../types'
import { convertNewLinesToBrTags } from '../../utils'

interface DescriptionProps extends FieldProps {
  description?: string
  richTextDescription?: string
  borderRadius?: string | number
}

const ModalDescription = ({ onChange, description, richTextDescription }: DescriptionProps) => {
  const characterLimit = 15000
  const [value, setValue] = useState<string | undefined>(
    richTextDescription || convertNewLinesToBrTags(description || '')
  )
  const internalValue = useRef(value)

  const onTinyMCEChange = useCallback(
    (plainText: string, richText: string) => {
      onChange({
        name: 'description',
        value: plainText,
      })
      onChange({
        name: 'richTextDescription',
        value: richText,
      })
      internalValue.current = richText
    },
    [onChange]
  )

  useEffect(() => {
    if (richTextDescription !== undefined) {
      if (richTextDescription !== internalValue.current) {
        setValue(value !== richTextDescription ? richTextDescription : undefined) // imp: value is set to undefined to re-render TinyMCEEditor
        internalValue.current = richTextDescription
      }
      if (value === undefined) setValue(richTextDescription)
    }
  }, [richTextDescription, value])

  return (
    <TinyMCEEditor
      initialValue={value}
      placeholder="Description"
      maxLength={characterLimit}
      onChange={onTinyMCEChange}
    />
  )
}
ModalDescription.displayName = 'ModalDescription'

export default React.memo(ModalDescription)
